import { faSlidersSolid } from '@/lib/fa'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'

import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { useRaportForm } from '@/modules/printouts/context/RaportFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'

const Options = () => {
    const { data, setData } = useRaportForm()
    const { t } = useLocalize()

  return (
     <div className="tw-flex tw-justify-between">
      <div className="tw-flex tw-flex-1 tw-items-start tw-gap-2 tw-font-medium tw-text-content-base">
        <StageHeader title={t('printout.options')} textSize="sm" icon={faSlidersSolid} />

        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1">

        <CheckboxWithLabelField
          field="separateFiles"
          data={data}
          setData={setData}
          label={t('printout.print-to-separate-files')}
          />
        {/* 
        <Divider />
        <CheckboxWithLabelField
          field="issuerSignature"
          data={data}
          setData={setData}
          label={t('printout.issuer-signature')}
          />
        <CheckboxWithLabelField
          field="driverSignature"
          data={data}
          setData={setData}
          label={t('printout.driver-signature')}
          />
        */}
          </div>
      </div>
    </div>
  )
}

export default Options
